import { Panel } from '@app/components/common/Collapse/Collapse';
import { IDealRoomSectionContent } from '@app/interfaces/deal-room';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sectionContentMap } from '../DealRoomLanding';
import * as S from '../DealRoomLanding.styles';
import { useSubMenuMouseflow } from '@app/hooks/useSubMenuMouseflow';
import { scrollToSection } from '@app/utils/scrollToSection';

interface InsuranceCoverageSharedBuildingProps {
  section: IDealRoomSectionContent;
}

export const InsuranceCoverageSharedBuilding: React.FC<InsuranceCoverageSharedBuildingProps> = ({ section }) => {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState<string>('');

  useSubMenuMouseflow(activeKey, (key) => {
    const sub = section.subMenu?.find((s) => s.key === key);
    return sub?.label || t(sub?.labelKey || key);
  });

  const getSectionContent = (section: IDealRoomSectionContent) => {
    const key = section.key as keyof typeof sectionContentMap;
    const content = sectionContentMap[key];
    return content ? content(section) : null;
  };

  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash) {
        const hashKey = window.location.hash.replace('#', '');

        // check if this section has a subMenu containing the hashKey
        const subMatch = section.subMenu?.find((subSection) => subSection.key === hashKey);

        if (subMatch) {
          setActiveKey(subMatch.key);
        }
      }
    };

    // Run on mount
    handleHashChange();

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [section.subMenu]);

  useEffect(() => {
    setTimeout(() => scrollToSection(activeKey), 400);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey]);

  return (
    <>
      {section.subMenu && section.subMenu.length > 0 && (
        <S.ChildContainer className="child-container">
          <S.ChildCollapse accordion activeKey={activeKey} onChange={(key) => setActiveKey(key as string)}>
            {section?.subMenu?.map((subSection) => (
              <Panel
                id={subSection.key}
                header={subSection.label ? subSection.label : t(subSection.labelKey)}
                key={subSection.key}
              >
                {getSectionContent(subSection)}
              </Panel>
            ))}
          </S.ChildCollapse>
        </S.ChildContainer>
      )}
    </>
  );
};
